export default (size) => {
  return Math.round(size / 1024 / 1024);
};
